export default __webpack_public_path__ + "static/media/logo2.36d466b8.jpg";